import { useState, useEffect, useMemo, useRef } from 'react';
import EditableField from '../../../../components/EditableFields';
import BooleanField from '../../../../components/BooleanField';
import DescripcionActividadSolicitud from '../components/infoSolicitudes';
import Cotizaciones from '../Modulos/Cotizaciones';
import NotificacionSolicitudes from '../Modulos/Notificaciones_solicitudes';
import VistaSolicitudes from '../Modulos/Vistas_solicitudes';
import ModuloHistorial from '../../../../components/Historial/Historial';
import PreguntasComponent from '../Modulos/Preguntas';
import { 
  Edit3, 
  AlertTriangle,
  DollarSign, 
  Bell, 
  Eye, 
  FileText,
  AlertCircle,
  Clock,
  User,
  Info,
} from 'lucide-react';
import HistorialPagosWidget from '../../Contabilidad/Modulos/ListaPagos';
import WompiPagoWidget from '../../Contabilidad/Modulos/WompiPago';
import PlantillaDetalle from '../../../../components/PlantillaLayout/PlantillaDetalle';
import { useDetalleSolicitudModel } from '../../../../modelos/Solicitudes/modeloSolicitud';
import { toast } from 'react-toastify';
import { useDialog } from '../../../../components/Dialogs/Dialogprovider';

const AdminView = ({
  solicitud,
  usuario,
  isAdmin,
  configuracion,
  cliente,
  //OPCIONES DE LISTA
  tipoServiciosListAdmin,
  materiasOptions,
  busquedaClientesOptions,
  estadoSolicitudVisibles,
  //FUNCIONES DE ACCION
  handleSave,
  handleEnviarPregunta,
  auxiliarBusqueda,
  deleteCotizacionLocal,
  addNewCotizacion,
  agendarTrabajo,

  activeTab, 
  setActiveTab,
}) => {

  const adminTabs = useMemo(() => {
    if (!solicitud) return [];

    // 1. Calculamos los conteos de forma segura
    const countCotizaciones = solicitud?.cotizaciones?.filter(cot => cot.cotizacion > 0).length || 0;
    
    const countVistas = solicitud?.tutorVistaSolicitud?.length || 0;

    const countPreguntas = solicitud?.preguntas?.filter(pregunta => 
      !pregunta.respuesta || pregunta.respuesta.length === 0
    ).length || 0;

    const countPagos = solicitud?.pagos?.length || 0;

    const baseTabs = [
      { id: 'general', label: 'General', icon: FileText },
      { 
        id: 'cotizaciones', 
        label: 'Cotizaciones', 
        icon: DollarSign, 
        count: countCotizaciones 
      },    
      { id: 'notificaciones', label: 'Notificaciones', icon: Bell },
      { 
        id: 'vistas', 
        label: 'Vistas', 
        icon: Eye, 
        count: countVistas 
      },
      { id: 'historial', label: 'Historial', icon: Eye },
      { 
        id: 'preguntas', 
        label: 'Preguntas', // Corregido capitalización
        icon: DollarSign, 
        count: countPreguntas 
      }, 
      { 
        id: 'pagos', 
        label: 'Pagos', 
        icon: DollarSign, 
        count: countPagos 
      }, 
    ];

    // 2. Retornamos el array con los counts ya procesados
    return baseTabs.filter(tab => {
      // Muestra la pestaña 'Tesis' solo si el servicio es de tipo 'TESIS'
        if (tab.id === 'pagos') {
          return countPagos > 0;
        }

        if (tab.id === 'preguntas') {
          return countPreguntas > 0;
        }
          
        return true;
    });
 


  }, [solicitud, isAdmin]); // Se recalcula cada vez que la solicitud cambie
  const PIN_ACCIONES = process.env.REACT_APP_PINACCIONES;
  const {
    deletePagoSolicitud,
    actualizarSolicitud,
  } = useDetalleSolicitudModel();
  const dialogs = useDialog();


  const handleDeletePago = (pagoId) => {

    const onConfirmDeletion = (enteredPin) => {

      if (enteredPin === PIN_ACCIONES) {
          // PIN correcto: elimina el pago y muestra éxito
          deletePagoSolicitud(solicitud.nombreEmpresa , solicitud.id ,pagoId );
          //dialogs.showSuccess('El pago ha sido eliminado correctamente.');

        } else {
          // PIN incorrecto: muestra error
          toast.error(`Error: la contraseña no es correcta`);
        }

    };

    dialogs.showConfirmWithPin(
        `¿Estás seguro de que deseas eliminar este pago? Esta acción requiere autorización.`,
        onConfirmDeletion, // Pasa la función de callback
        'Confirmar Eliminación'
    );

  }


  //RENDEREIZADO DE TABS
  const renderGeneralTab = () => {

    return(
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <EditableField
            field="Servicio"
            label="Tipo de Servicio"
            value={solicitud.Servicio}
            type="react-select"
            options={tipoServiciosListAdmin}
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="materia"
            label="Materia"
            value={solicitud.materia}
            type="react-select"
            options={materiasOptions}
            isAdmin={isAdmin}
            onSave={handleSave}
            placeholder="Ingrese la materia"
          />

          <EditableField
            field="fechaentrega"
            label="Fecha de entrega"
            value={solicitud.fechaentrega}
            type="datetime"
            isAdmin={isAdmin}
            onSave={handleSave}
            placeholder="Ingrese la fecha"
          />  
          
          <EditableField
            label="Id Solicitud"
            value={solicitud.id}
            type="text"
            isAdmin={false}
            onSave={handleSave}
          />
        
        {/* Clientes options */}
          <EditableField
            field="cliente"
            label="Numero del cliente"
            value={solicitud.cliente}
            onInputChange={auxiliarBusqueda} // Búsqueda en tiempo real
            type="react-select"
            options={busquedaClientesOptions}
            isAdmin={isAdmin} //cliente, hay que permitir cambio
            onSave={handleSave}
          />

          <EditableField
            label="Fecha de sistema"
            value={solicitud.fechasistema}
            type="datetime"
            isAdmin={false}
            onSave={handleSave}
          />  

          <EditableField
            field="Estado"
            label="Estado"
            value={solicitud.Estado}
            type="react-select"
            options={estadoSolicitudVisibles}
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          {/* COSAS POR IA */}
          <EditableField
            field="predicionesIA.carreraIa"
            label="Carrera IA"
            value={solicitud?.predicionesIA?.carreraIa}
            type="text"
            isAdmin={false}
          />

          <EditableField
            field="predicionesIA.carreraSugerencia"
            label="Carrera Sugerencia"
            value={solicitud?.predicionesIA?.carreraSugerencia}
            type="text"
            isAdmin={false}
          />

          <EditableField
            field="predicionesIA.materiaIA"
            label="Materia IA"
            value={solicitud?.predicionesIA?.materiaIA}
            type="text"
            isAdmin={false}
          />

          <EditableField
            field="predicionesIA.materiaSugerencia"
            label="Materia Sugerencia"
            value={solicitud?.predicionesIA?.materiaSugerencia}
            type="text"
            isAdmin={false}
          />


          {/* Permitir inyeccion de solicitud pro plataforma */}
          
          { solicitud.esProPlataforma() && (
          <div className="md:col-span-2 mt-4 p-4 border-l-4 border-blue-500 bg-slate-50 rounded-r-lg">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalles de ProPlataforma</h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <EditableField
                field="proPlataforma.materia"
                label="Materia Asignada"
                value={solicitud.proPlataforma?.materia}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.fase"
                label="Fase"
                value={solicitud.proPlataforma?.fase}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.plataforma"
                label="Plataforma"
                value={solicitud.proPlataforma?.plataforma}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <BooleanField
                field="proPlataforma.manejoPlataforma"
                label="Manejo de plataforma nosotros"
                value={solicitud.proPlataforma.manejoPlataforma}
                isAdmin={true}
                displayAs='toggle'
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.semestre"
                label="Semestre"
                value={solicitud.proPlataforma?.semestre}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <EditableField
                field="proPlataforma.fechaRealUnad"
                label="Fecha Real UNAD"
                value={solicitud.proPlataforma?.fechaRealUnad}
                type="date"
                isAdmin={isAdmin}
                onSave={handleSave}
              />

              <BooleanField
                field="proPlataforma.esColaborativo"
                label="Es colaborativo?"
                value={solicitud.proPlataforma.esColaborativo}
                isAdmin={true}
                displayAs='toggle'
                onSave={handleSave}
              />

              <BooleanField
                field="proPlataforma.tieneForo"
                label="Tiene foro?"
                value={solicitud.proPlataforma.tieneForo}
                isAdmin={true}
                displayAs='toggle'
                onSave={handleSave}
              />

            </div>
          </div>
          )}
          
        </div>

       

        <div className="relative overflow-hidden bg-white border-2 border-emerald-500/20 rounded-2xl shadow-sm">
          {/* Decoración de fondo */}
          <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-emerald-500/5 rounded-full" />
          
          <div className="p-5 flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-emerald-600 text-white shadow-lg shadow-emerald-200">
              <DollarSign size={32} strokeWidth={2.5} />
            </div>
            
            <div className="flex-1 w-full min-w-0 custom-editable-price">
              <EditableField
                field="precioCobradoCliente"
                label="MONTO TOTAL COBRADO AL CLIENTE"
                value={solicitud.precioCobradoCliente}
                type="text"
                isAdmin={isAdmin}
                onSave={handleSave}
                placeholder="0.00"
              />
              <p className="mt-1 text-xs text-emerald-600 font-medium flex items-center gap-1">
                <Info size={12} />
                Este valor es el que se muestra en el resumen financiero de la solicitud.
              </p>
            </div>

            <div className="hidden md:block px-6 border-l border-gray-100 text-right">
                <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Estado de Pago</span>
                <span className={`inline-flex items-center mt-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${solicitud.precioCobradoCliente > 0 ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`}>
                   {solicitud.precioCobradoCliente > 0 ? 'Cotizado' : 'Pendiente'}
                </span>
            </div>
          </div>
        </div>

      
        <div className="bg-white p-4 rounded-lg border">
          
          <DescripcionActividadSolicitud 
            key={solicitud.ultimaModificacion} 
            solicitud={solicitud}
            isAdmin = {true}
            onUpdateSolicitud = {handleSave}
            />
          
          <p className="text-sm text-gray-600 mt-2">{solicitud.formato}</p>
        </div>
      </div>
    );
  }

  //APROBAR O DESAPROBAR PAGO PENDIENTE
  const handleAprobarPago = async (indexPago, boolAprobado) => {
    const finalupdate = {
        "value" : boolAprobado,
        "elementId": indexPago,
      }
      await actualizarSolicitud(solicitud.id,solicitud.nombreEmpresa,'pagos.estado',finalupdate,'array');
  }


  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return renderGeneralTab();
      case 'cotizaciones':
        return <Cotizaciones
            solicitud={solicitud}
            deleteCotizacionLocal={deleteCotizacionLocal}
            cliente={cliente}
            addNewCotizacion={addNewCotizacion}
            configuracion={configuracion}
            onAgendarTrabajo={agendarTrabajo}
          />
      case 'notificaciones':
        return <NotificacionSolicitudes solicitud={solicitud} />
      case 'vistas':
        return  <VistaSolicitudes solicitud={solicitud} />
      case 'historial':
        return <ModuloHistorial historial={solicitud.historial} />
      case 'preguntas':
        return <PreguntasComponent
            preguntas={solicitud.preguntas || []}
            usuarioActual={usuario}
            isAdmin={isAdmin}
            onEnviarPregunta={handleEnviarPregunta}
            onResponderPregunta={handleEnviarPregunta}
          />
      case 'pagos':
        return <HistorialPagosWidget 
              pagos={solicitud.pagos} // O solicitud.pagos
              handleDeletePago={handleDeletePago}
              //estadosArchivos={estadosArchivos}
              handleRechazarPago={handleAprobarPago}
              handleAprobarPago={handleAprobarPago}
            />
    }
  }

  return (
    <PlantillaDetalle
      tabs={adminTabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      >
        {renderTabContent()}
      </PlantillaDetalle>
  );

}

export default AdminView